/**
 * 将订单地址中的电话号码规范化为“纯数字 + 国家码”格式（AppLovin user_data.phone 要求
 * digits only and include the country code，不含 + 和格式字符）。
 * 约定与 facebookProvider/snapchatProvider 一致：telephone 存本地号码、tel_code 存国家码。
 * 拼接国家码时去除国内长途前导 0（英国 020、法国 06、德国 030 等），意大利是例外需保留。
 * 无法可靠确定国家码（无 tel_code 且原号码不带 + 前缀）时返回空字符串，调用方应省略该字段。
 */
export function toIntlPhoneDigits(telCode?: string | null, telephone?: string | null): string {
  if (!telephone) return '';
  const digits = telephone.replace(/\D/g, '');
  if (!digits) return '';
  if (telephone.trim().startsWith('+')) return digits;
  const code = telCode?.replace(/\D/g, '');
  if (!code) return '';
  // 意大利国际格式保留前导 0，其余国家计划去除国内长途前缀
  const national = code === '39' ? digits : digits.replace(/^0+/, '') || digits;
  return `${code}${national}`;
}
